<template>
  <div class="tble">
    <!-- <div class="mb10 flex flex-end item-center">
      <el-tooltip effect="dark" placement="left">
        <div slot="content">
          默认权重为1；<br />计算方式：权重数/当前月份*合计
        </div>
        <i class="el-icon-warning-outline mr10"></i>
      </el-tooltip>
      <el-button size="small" type="primary" @click="smart">智能填充</el-button>
    </div> -->
    <div style="color: #ff7f10" class="mb10 fz16">
      <!-- 请输入KR比例，总比例=100%，若比例有剩余则不可进行下一步 -->
      请输入KR比例
    </div>

    <div class="tables">
      <el-form
        :rules="model.rules"
        :model="model"
        ref="ruleForm"
        label-width="0px"
        class="okr-table-form"
      >
        <el-table
          :data="model.tableData"
          row-key="id"
          :key="itemkey"
          border
          ref="table"
          max-height="400px"
          default-expand-all
          :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          :row-style="tableRowStyle"
        >
          <el-table-column
            v-show="tableHeader.length"
            v-for="(col, index) in tableHeader"
            :key="index"
            :min-width="index === 0 ? 120 : 103"
            :prop="col.columnName"
            :label="col.labelName"
            :column-key="index.toString()"
            :header-align="index === 0 ? 'left' : 'right'"
            :align="index === 0 ? 'left' : 'right'"
          >
            <template slot-scope="scope">
              <!-- 第一行 -->
              <template v-if="scope.$index === 0">
                <template v-if="index === 0">
                  <el-tooltip
                    :content="scope.row.goodsName"
                    placement="top-start"
                  >
                    <div
                      style="display: inline-block;max-width:200px;line-height:13px"
                      class="text-overflow"
                    >
                      {{ scope.row[col.columnName] }}
                    </div>
                  </el-tooltip>
                  <span
                    v-if="
                      col.columnName === 'goodsName' &&
                        scope.row.goodsName !== '其他'
                    "
                    class="add-wrapper"
                    style="display: inline-block"
                    @click="add(scope.row, scope.$index)"
                  >
                    <span class="hmicon icon-hao pointer"></span>
                  </span>
                  <span
                    v-if="
                      col.columnName === 'goodsName' &&
                        scope.row.goodsName !== '' &&
                        scope.row.goodsName !== '其他'
                    "
                    class="minus-wrapper"
                    style="display: inline-block"
                    @click="del(scope.row, scope.$index)"
                  >
                    <span class="hmicon icon-jianhao pointer"></span>
                  </span>
                </template>
                <template v-else>
                  ￥
                  <el-input
                    type="number"
                    size="small"
                    class="mr10 ipt"
                    style="width: 150px"
                    v-model.trim="scope.row[col.columnName]"
                    @blur="otherBlur(scope.row, col.columnName)"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </template>

              <!-- 其余行 -->
              <template v-else>
                <template v-if="index === 0">
                  <el-tooltip
                    :content="scope.row.goodsName"
                    placement="top-start"
                  >
                    <div
                      style="display: inline-block;max-width:200px;line-height:13px"
                      class="text-overflow"
                    >
                      {{ scope.row[col.columnName] }}
                    </div>
                  </el-tooltip>
                  <span
                    v-if="
                      col.columnName === 'goodsName' &&
                        scope.row.goodsName !== '其他'
                    "
                    class="add-wrapper"
                    style="display: inline-block"
                    @click="add(scope.row, scope.$index)"
                  >
                    <span class="hmicon icon-hao pointer"></span>
                  </span>
                  <span
                    v-if="
                      col.columnName === 'goodsName' &&
                        scope.row.goodsName !== '' &&
                        scope.row.goodsName !== '其他'
                    "
                    class="minus-wrapper"
                    style="display: inline-block"
                    @click="del(scope.row, scope.$index)"
                  >
                    <span class="hmicon icon-jianhao pointer"></span>
                  </span>
                </template>
                <template v-else>
                  ￥
                  <el-input
                    type="number"
                    size="small"
                    class="mr10 ipt"
                    style="width: 150px"
                    v-model.trim="scope.row[col.columnName]"
                    @blur="otherBlur(scope.row, col.columnName)"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </template>
              <template v-if="scope.row.tt">
                剩余{{ scope.row.tt }}
              </template>
              <!-- <template v-if="scope.$index === 0">
              
              <template v-if="index===0">
                 <el-tooltip :content="scope.row.goodsName" placement="top-start">
                <div style="display: inline-block;max-width:200px;line-height:13px" class="text-overflow">{{scope.row[col.columnName]}}</div>
                  </el-tooltip>
                   <span
                v-if="
                  col.columnName === 'goodsName' &&
                  scope.row.goodsName !== '其他'
                "
                class="add-wrapper"
                style="display: inline-block"
                @click="add(scope.row, scope.$index)"
              >
                <span class="hmicon icon-hao pointer"></span>
              </span>
              <span
                v-if="
                  col.columnName === 'goodsName' &&
                  scope.row.goodsName !== '' &&
                  scope.row.goodsName !== '其他'
                "
                class="minus-wrapper"
                style="display: inline-block"
                @click="del(scope.row, scope.$index)"
              >
                <span class="hmicon icon-jianhao pointer"></span>
              </span>
                 
              </template>
              <template v-else>
                <span
                v-if="
                  col.columnName === 'planValue' && scope.row.planValue !== ''
                "
                >￥</span
              >
               {{index===2?scope.row[col.columnName]!=""&&scope.row[col.columnName]!=null?toPriceNum(scope.row[col.columnName]):'':scope.row[col.columnName]}}
                 {{ col.columnName === "splitRatio" ? "%" : "" }}
              </template>
            </template> -->
              <!-- <template v-else >
              <template v-if="index===0">
                       <el-tooltip :content="scope.row.goodsName" placement="top-start">
                <div style="display: inline-block;max-width:200px;line-height:13px" class="text-overflow">{{scope.row[col.columnName]}}</div>
                  </el-tooltip>
                                 <span
                  v-if="
                    col.columnName === 'goodsName' &&
                    scope.row.goodsName !== '其他'
                  "
                  class="add-wrapper"
                  style="display: inline-block"
                  @click="add(scope.row, scope.$index)"
                >
                  <span class="hmicon icon-hao pointer"></span>
                </span>
                <span
                  v-if="
                    col.columnName === 'goodsName' &&
                    scope.row.goodsName !== '' &&
                    scope.row.goodsName !== '其他'
                  "
                  class="minus-wrapper"
                  style="display: inline-block"
                  @click="del(scope.row, scope.$index)"
                >
                  <span class="hmicon icon-jianhao pointer"></span>
                </span>
              </template>
              <template v-else>
                  <span
                  v-if="
                    col.columnName === 'planValue' && scope.row.planValue !== ''
                  "
                  >￥</span

                >  
                <span v-if="index===2">{{ scope.row[col.columnName] }}</span>
                 
                 <el-input
                  v-if="
                  col.columnName === 'splitRatio' &&
                  scope.row.goodsName !== '其他'
                "
                type="number"
                size="small"
                class="mr10 ipt"
                style="width: 150px"
                v-model.trim="scope.row[col.columnName]"
                @blur="otherBlur(scope.row, col.columnName)"
                placeholder="请输入"
              ></el-input>

              {{
                col.columnName === "splitRatio" &&
                scope.row.goodsName !== "其他"
                  ? "%"
                  : ""
              }}


              <span
                v-if="
                  scope.row.goodsName === '其他' &&
                  col.columnName === 'splitRatio'
                "
              >
                <span
                  v-if="
                    col.columnName === 'planValue' && scope.row.planValue !== ''
                  "
                  >￥</span
                >
                <span>
                  {{index===2?scope.row[col.columnName]!=""&&scope.row[col.columnName]!=null?toPriceNum(scope.row[col.columnName]):'':scope.row[col.columnName]}}
                  
                </span>
                {{ col.columnName === "splitRatio" ? "%" : "" }}
              </span>

              </template>

            </template> -->
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>
    <el-dialog
      width="1200px"
      title="添加商品"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <hm-shop-goods-okr
        v-if="dialogVisible"
        type="microShop"
        :params="row"
        :targeYear="targeYear"
        :visible="dialogVisible"
        @saveGoods="saveGoods"
        @close="dialogVisible = false"
      ></hm-shop-goods-okr>
    </el-dialog>
  </div>
</template>

<script>
import HmShopGoodsOkr from "@/components/HmShopGoodsOkr";
import { arrayUnique2, random, ToFixed } from "@/utils/utils";

export default {
  components: { HmShopGoodsOkr },
  props: {
    data: {
      default: function() {
        return [];
      },
      type: Array
    },
    headersList: {
      default: function() {
        return [];
      },
      type: Array
    },
    targeYear: {
      type: String,
      default: ""
    },
    params: {
      default: function() {
        return {};
      },
      type: Object
    }
  },
  data() {
    const patternList = (rule, val, callback) => {
      let flag = false;
      this.model.list.forEach(v => {
        if (v.splitRatio === "") {
          flag = true;
        }
      });
      if (flag) {
        return callback(new Error("请填写所有项"));
      }
      callback();
    };
    return {
      model: {
        rules: {
          splitRatio: [{ required: true, validator: patternList }]
        },
        tableData: this.data
      },
      show: true,
      itemkey: "",
      monthWeight: {
        monthWeight1: 1,
        monthWeight2: 1,
        monthWeight3: 1,
        monthWeight4: 1,
        monthWeight5: 1,
        monthWeight6: 1,
        monthWeight7: 1,
        monthWeight8: 1,
        monthWeight9: 1,
        monthWeight10: 1,
        monthWeight11: 1,
        monthWeight12: 1
      },

      dialogVisible: false,
      tableType: "",
      returnedItem: {},
      monthList: [],
      tableData: this.data,
      addTable: {
        id: 3333,
        date: "我是新加入的",
        name: "",
        address: "上海市普陀区金dawd 沙江路 1519 弄",
        children: []
      },
      row: {},
      mon: {
        month1: "",
        month2: "",
        month3: "",
        month4: "",
        month5: "",
        month6: "",
        month7: "",
        month8: "",
        month9: "",
        month10: "",
        month11: "",
        month12: ""
      },
      currentAllNode: [],
      parentItem: {},
      otherFocusChange: false,
      currentVal: "",
      other: {
        total: "",
        parent: 0,
        id: "",
        goodsName: "其他",
        month1: "",
        month2: "",
        month3: "",
        month4: "",
        month5: "",
        month6: "",
        month7: "",
        month8: "",
        month9: "",
        month10: "",
        month11: "",
        month12: ""
      },
      weight: 0,
      tableHeader: this.headersList,
      addRow: {},
      copyTableData: [],
      arr: [],
      repeatFlag: false,
      isOutputing: false
    };
  },
  computed: {},
  watch: {
    data(val) {
      this.copyTableData = JSON.parse(JSON.stringify(val));
      this.model.tableData = val;
    },
    headersList(val) {
      this.tableHeader = val;
      val.forEach(v => {
        this.addRow[v.columnName] = "";
      });
      this.addRow.splitRatio = 0;

      // console.log(" this.tableHeader", this.tableHeader);
    },
    params(val) {
      // console.log("val", val);
    }
  },
  created() {
    this.monthList = [];
    this.tableHeader = [];
  },
  mounted() {},
  methods: {
    // //导出excel
    // output() {
    //   require.ensure([], () => {
    //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
    //     // this.isOutputing = true;
    //     const list = treeConvertToArr(this.columnList);
    //     console.log("list: ", list);

    //     // const tHeader = ["ID(请勿修改)", "目标商品", "目标值"];
    //     const tHeader = this.$refs.table.columns
    //       .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
    //       .filter(o => o);
    //     console.log("tHeader: ", tHeader);
    //     // const filterVal = ["id", "goodsName","planValue"];
    //     let filterVal = [];
    //     if (list.length > 0) {
    //       filterVal = this.$refs.table.$children

    //         .map(o => o._props.prop)
    //         .filter(o => o);
    //     }
    //     console.log("filterVal: ", filterVal);
    //     const data = this.formatJson(filterVal, list);
    //     exportJsonToExcel(
    //       tHeader,
    //       data,
    //       "导出模板" + new Date().toLocaleString()
    //     );
    //     // this.isOutputing = false;
    //     this.$emit("outputing", false);
    //   });
    // },
    // formatJson(filterVal, jsonData) {
    //   return jsonData.map(v => filterVal.map(j => v[j]));
    // },
    tableRowStyle({ row }) {
      return `background:rgba(221, 221, 221, ${row.backGround})`;
    },
    mapBackGroundArr(arr, num) {
      arr.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.backGround = num - 0.15;
          this.mapBackGroundArr(item.children, num - 0.15);
        }
      });
    },
    smart() {
      let monthWeight = 0;
      this.weight = 0;
      let month = {};
      for (let i = 1; i <= 12; i++) {
        monthWeight += this.monthWeight["monthWeight" + i] * 1;
        this.weight += this.monthWeight["monthWeight" + i] * 1;
        month["month" + i] = "";
      }

      for (let i = 1; i <= 12; i++) {
        this.model.tableData[0]["month" + i] = (
          (this.model.tableData[0].total *
            this.monthWeight["monthWeight" + i]) /
          monthWeight
        ).toFixed(2);
      }

      this.$set(this.model.tableData, 0, this.model.tableData[0]);
      this.smartAllMonth(this.model.tableData[0].children, this.weight);
    },
    //智能填充所有月份递归
    smartAllMonth(arr, monthWeight) {
      arr.forEach(items => {
        console.warn("items", items);
        //遍历树
        if (items.parent !== 1) {
          for (let i = 1; i <= 12; i++) {
            items["month" + i] = (
              (items.total * this.monthWeight["monthWeight" + i]) /
              monthWeight
            ).toFixed(2);
            // items["month" + i] = new Number(items["month" + i]);
          }
        }
        if (items.children && items.children.length) {
          this.smartAllMonth(items.children, this.weight);
        }
      });
    },
    monthFocus(row, index) {
      // let item = JSON.parse(JSON.stringify(row));

      // this.$set(this.$refs.table.store.states.lazyTreeNodeMap, row.id, row);
      this.$forceUpdate();
    },
    monthBlur(row, num) {
      this.row = row;
      this.row.num = num;
      this.model.tableData[0]["totalVal" + num] = 0;
      this.queryAllMonthVal(this.model.tableData, row.id, num);
      this.$set(this.model.tableData, 0, this.model.tableData[0]);
      this.$forceUpdate();
      this.queryTotal();
    },
    monthChange() {
      // if (index === 0) {
      //   this.$set(this.tableData, 0, this.tableData[0]);
      // }

      // this.$set(this.$refs.table.store.states.lazyTreeNodeMap, row.id, row);
      this.$forceUpdate();
    },
    otherFocus(row) {
      this.mapTree(this.model.tableData);
      this.queryTree(this.model.tableData, row.id);

      if (row.total === "" || !row.total) {
        this.otherFocusChange = false;
      } else {
        if (row.children && row.children.length > 0) {
          this.otherFocusChange = true;
        } else {
          this.otherFocusChange = false;
        }
        this.currentVal = JSON.parse(JSON.stringify(row.total));
      }

      this.$set(
        this.$refs.table.store.states.lazyTreeNodeMap,
        row.id,
        row.children
      );
    },
    queryValue(row) {
      for (let key in row) {
        if (key.indexOf("splitValue") === 0 || key === "planValue") {
          row[key] = (
            this.model.tableData[0][key] *
            row.splitRatio *
            0.01
          ).toFixed(2);
        }
      }
    },
    filterGt0OrFixed2(prop) {
      // prop = prop.replace(/^(0+)/, ""); //过滤0开头
      prop = prop.replace(/[^\d.]/g, ""); //仅保留数字和"."
      prop = prop.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      prop = prop
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      prop = prop.replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (prop.indexOf(".") < 0 && prop != "") {
        //首位是0的话去掉
        prop = parseFloat(prop);
      }
      return prop;
    },
    otherBlur(row, key) {
      console.log(row)
      row[key] = ToFixed(row[key] || 0, 2);
      let reduceValue = 0;
      for (let i = 0; i < this.model.tableData.length; i++) {
        let data = this.model.tableData[i];
        if (this.hasChildren(data)) {
          let children = data.children;
          for (let j = 0; j < children.length; j++) {
            if (children[j].planValue) {
              reduceValue += parseInt(children[j].planValue);
            }
          }
        }
      }
      this.model.tableData[0].tt = this.model.tableData[0].planValue - reduceValue;
    },
    hasChildren(data) {
      if (data.children && data.children.length > 0) {
        return true;
      }
       return false;
    },
    //实时求出其他合计
    queryDiff(row) {
      this.queryTree(this.model.tableData, row.id, this.model.tableData[0]);
    },
    queryRepeat(arr, id) {
      arr.forEach(items => {
        //遍历树
        if (items.id == id) {
          this.repeatFlag = true;

          return;
        }
        if (items.children && items.children.length) {
          this.queryRepeat(items.children, id);
        }
      });
    },
    saveGoods(data) {
      data.forEach(v => {
        v.goodsName = v.name;
      });
      // this.queryRepeat(this.model.tableData, data.id);
      // console.log(this.repeatFlag);
      // if (!this.repeatFlag) {
      if (this.model.tableData[0].goodsName === "") {
        // this.$set(this.tableData[0], data);
        Object.assign(this.model.tableData[0], data[0]);

        this.$forceUpdate();
        this.dialogVisible = false;
        this.itemkey = random(1, 100);
      } else {
        data.forEach(v => {
          this.$set(v, "planValue", "");
          this.$set(v, "splitRatio", "");
        });
          if (this.row.hasOwnProperty("children") && this.row.children.length) {
          // let row = Object.assign({}, this.addRow, data);

          // this.row.children.splice(this.row.children.length - 1, 0, row);
          this.row.children.push(...data);
          this.row.children = arrayUnique2(this.row.children, "id");
          this.$forceUpdate();
          this.dialogVisible = false;
          this.itemkey = random(1, 100);
          this.$set(
            this.$refs.table.store.states.lazyTreeNodeMap,
            this.row.id,
            this.row.children
          );

          // this.otherBlur(row);
        } else {
          this.row.children = [];
          this.row.children.push(...data);
          this.row.children = arrayUnique2(this.row.children, "id");
          // this.row.children.push(Object.assign({}, this.addRow, data));
          // this.other.id = random(1, 100);
          // let row = JSON.parse(JSON.stringify(this.addRow));
          // row.goodsName = "其他";
          // row.id = random(1, 100);
          // this.row.children.push(Object.assign({}, row));
          this.$forceUpdate();
          this.dialogVisible = false;
          this.itemkey = random(1, 100);

          this.$set(
            this.$refs.table.store.states.lazyTreeNodeMap,
            this.row.id,
            this.row.children
          );
          // this.otherBlur(this.row.children[0]);
        }
      }
      this.mapBackGroundArr(this.model.tableData, 1);
      // } else {
      //   this.$message({
      //     message: "请勿选择重复的商品",
      //     type: "warning"
      //   });
      //   this.repeatFlag = false;
      // }
    },
    add(row) {
      console.log("add row::", row)
      if (this.model.tableData[0].goodsName === "") {
        this.row = this.params;
      } else {
        this.$forceUpdate();
        this.row = row;
      }
      this.repeatFlag = false;
      this.dialogVisible = true;
    },
    del(row, i) {
      if (i === 0) {
        // this.model.tableData = JSON.parse(JSON.stringify(this.copyTableData));

        for (let key in this.model.tableData[0]) {
          if (key !== "planValue" && key !== "id" && key !== "children") {
            this.model.tableData[0][key] = "";
          }
        }
      } else {
        this.delFindById(this.model.tableData, row.id);
      }
    },
    toPriceNum(num) {
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
    //遍历节点，删除节点
    delFindById(arr, id) {
      this.returnedItem = {};
      arr.forEach((item, index) => {
        //利用foreach循环遍历
        if (item.id == id) {
          //判断递归结束条件
          if (item.children && item.children.length >= 1) {
            this.$confirm("该节点下存在子节点,是否确定删除?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              // if (arr.length === 2) {
              //   arr.splice(0, 2);
              // } else {
              //   arr[arr.length - 1].splitRatio =
              //     arr[arr.length - 1].splitRatio + item.splitRatio;
              //   arr.splice(index, 1);
              // }
              arr.splice(index, 1);
              this.itemkey = random(1, 100);
            });
          } else {
            // if (arr.length === 2) {
            //   arr.splice(0, 2);
            // } else {
            //   arr[arr.length - 1].splitRatio =
            //     arr[arr.length - 1].splitRatio + item.splitRatio;

            //   arr.splice(index, 1);
            // }
            this.$set(
              arr[arr.length - 1],
              "splitRatio",
              arr[arr.length - 1].splitRatio * 1 + item.splitRatio * 1
            );
            arr.splice(index, 1);
            this.itemkey = random(1, 100);
          }
          return item;
        } else if (item.children && item.children.length > 0) {
          //判断chlidren是否有数据
          this.delFindById(item.children, id); //递归调用
        }
      });
    },
    //得到当前层级所有节点
    queryTree(arr, id, items) {
      arr.forEach(item => {
        //利用foreach循环遍历
        if (item.id == id) {
          //判断递归结束条件
          arr.forEach((v, i) => {
            this.$set(arr, i, v);
          });
          this.currentAllNode = arr;
          this.parentItem = items;
          let total = 0;
          arr.forEach(v => {
            if (v.goodsName !== "其他") {
              total +=
                v.splitRatio === "" || !v.splitRatio ? 0 : v.splitRatio * 1;
            }
          });
          let childrenTotal = 0;
          if (item.hasOwnProperty("children")) {
            item.children.forEach(v => {
              if (v.goodsName !== "其他") {
                childrenTotal +=
                  v.splitRatio === "" || !v.splitRatio ? 0 : v.splitRatio * 1;
              }
            });
          }

          if (this.parentItem.splitRatio - total < 0) {
            this.$message({
              message: `当前层级合计比例不能超过父级比例(${this.parentItem.splitRatio})，请重新设置!!`,
              type: "warning"
            });
            item.splitRatio = 0;
            this.otherBlur(item);
          } else {
            if (childrenTotal > item.splitRatio) {
              this.$message({
                message: `当前层级合计比例不能小于子级比例(${childrenTotal})，请重新设置!!`,
                type: "warning"
              });
              item.splitRatio = childrenTotal;
              this.queryValue(item);
              // this.otherBlur(item);
            } else {
              this.$set(
                arr[arr.length - 1],
                "splitRatio",
                this.parentItem.splitRatio - total
              );
              this.queryValue(arr[arr.length - 1]);
              if (item.hasOwnProperty("children")) {
                if (item.children.length) {
                  this.$set(
                    item.children[item.children.length - 1],
                    "splitRatio",
                    item.splitRatio - childrenTotal
                  );
                  this.queryValue(item.children[item.children.length - 1]);
                }
              }

              this.$forceUpdate();
            }
          }
          return arr;
        }
        if (item.children && item.children.length > 0) {
          //判断chlidren是否有数据

          this.queryTree(item.children, id, item); //递归调用
        }
      });
    },
    //遍历所有数结构数据并把所有节点清空
    forTree(arr) {
      arr.forEach(items => {
        //遍历树
        items.total = "";
        if (items.children && items.children.length) {
          this.forTree(items.children);
        } else {
          return;
        }
      });
    },
    mapTree(arr) {
      arr.forEach(items => {
        //遍历树
        Object.assign(items, items);
        if (items.children && items.children.length) {
          this.mapTree(items.children);
        }
      });
    },
    //新增子集
    addTreeById(arr, id, row) {
      arr.forEach((items, i) => {
        if (items.id === id) {
          if (items.hasOwnProperty("children") && items.children.length) {
            // this.row.children
            this.$set(items.children, i, row);
            // items.children.push(row);
          } else {
            items.children = [];
            // items.children.push(row);
            this.$set(items.children, i, row);
          }
          return items;
        }
        if (items.children && items.children.length) {
          this.addTreeById(items.children, id, row);
        }
      });
    },
    //递归求出行列合计
    queryAllMonthVal(arr, id, num) {
      arr.forEach(items => {
        //遍历树
        if (items.id == id) {
          //判断递归结束条件
          let total = 0;
          for (let i = 1; i <= 12; i++) {
            total += new Number(items["month" + i] || 0) * 1;
          }
        }
        if (items.parent !== 1) {
          this.model.tableData[0]["totalVal" + num] += items["month" + num] * 1;
        }

        if (items.children && items.children.length) {
          this.queryAllMonthVal(items.children, this.row.id, this.row.num);
        }
      });
    },
    //求出总目标合计
    queryTotal() {
      this.model.tableData[0].realTotal = 0;
      for (let i = 1; i <= 12; i++) {
        this.model.tableData[0].realTotal +=
          this.model.tableData[0]["totalVal" + i] === ""
            ? new Number(this.model.tableData[0]["month" + i] || 0) * 1
            : new Number(this.model.tableData[0]["totalVal" + i] || 0) * 1;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bm {
  border-bottom: 1px solid #ebeef5;
}
.el-icon-warning-outline {
  font-size: 20px;
}
.fz16 {
  font-size: 16px;
}
.tables {
  position: relative;
  .mask-layer {
    background: rgba(144, 144, 144, 1);
    position: absolute;
    left: 462px;
    right: 0;
    bottom: 15px;
    top: 107px;
  }
}
</style>
